import React from 'react'
import SvgKey from './svgKey'
import AmortImageBig from '../../static/amortBig.png'

const amortHeight = 525
const id = "bigger-than-1680"

const fn = (e) => {
  const amortImg = document.getElementById("biggerThan1680")
  const bounds = amortImg.getBoundingClientRect()
  const mouseRelativeX = e.clientX - bounds.left
  const mouseRelativeY = e.clientY - bounds.top

  const width = bounds.right - bounds.left

  const glassrect = document.getElementById(`${id}glassrect`)
  const svgkey = document.getElementById(`${id}svgkey`)

  if (e.clientY < bounds.top + 41) {
    glassrect.setAttribute('y', 0)
  } else if (e.clientY > bounds.bottom - 41) {
    glassrect.setAttribute('y', amortHeight - 41)
  } else {
    glassrect.setAttribute('y', mouseRelativeY - 41)
  }

  if (e.clientX < bounds.left + 180) {
    glassrect.setAttribute('x', 0)
  } else if (e.clientX > bounds.right - 100) {
    glassrect.setAttribute('x', width - 270)
  } else {
    glassrect.setAttribute('x', mouseRelativeX - 180)
  }

  if (e.clientY < bounds.top + 70) {
    svgkey.setAttribute('y', 0)
  } else if (e.clientY > bounds.bottom - 120) {
    svgkey.setAttribute('y', amortHeight - 188)
  } else {
    svgkey.setAttribute('y', mouseRelativeY - 70)
  }

  if (e.clientX < bounds.left + 230) {
    svgkey.setAttribute('x', 0)
  } else if (e.clientX > bounds.right - 140) {
    svgkey.setAttribute('x', width - 370)
  } else {
    svgkey.setAttribute('x', mouseRelativeX - 230)
  }

}

const biggerThan1680 = () => (
  <div style={{textAlign: 'center'}}>
    <div style={{position: 'relative', display: 'inline-block', width: 1410}}>
      <img
        id="biggerThan1680"
        src={AmortImageBig}
        height={`${amortHeight}px`}
      />
      <SvgKey
        id={id}
        onMouseMove={fn}
        transition={false}
        width={1410}
        height={amortHeight}
        cardX={950}
        cardY={200}
        whaleX={1100}
        whaleY={250}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      />
    </div>
  </div>
)

export default biggerThan1680


// WEBPACK FOOTER //
// ./src/finwhale/amort/BiggerThan1680.js